import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components/Text/Text';

export const Copy = styled(Text)`
  display: block;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
  margin-bottom: 14px;
`;

/** The picker and, under it, the New category fields: the list page's stack. */
export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
